import styles from "./AllGroups.module.css";
import { NewUserProfileType } from "../Types/userProfile";

import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import {
  DocumentData,
  QueryDocumentSnapshot,
  QuerySnapshot,
  addDoc,
  collection,
  doc,
  getDoc,
  getDocs,
  getFirestore,
  onSnapshot,
  orderBy,
  query,
  updateDoc,
  where,
} from "firebase/firestore";
import { app } from "../lib/firebase";
import { NewProjectProfileType } from "../Types/projectProfile";
import {
  IteratedDataSnapshot,
  child,
  get,
  getDatabase,
  push,
  ref,
} from "firebase/database";

import { NewGroupProfileType } from "../Types/groupProfile";
import { UserField } from "../Types/groupProfile";
import WelcomePage from "../WelcomePage/WelcomePage";
import MyLabProjects from "../MyLab/MyLabProjects";
import SubgroupSelect from "../Subgroups/SubgroupSelect";
import { addUserGroup, deleteGroup, UpdateGroupID } from "../lib/controller";
import UpdateUserPhotoURL from "../UserProfile/UpdateUserPhotoURL";
import CreatePhotoURL from "../UserProfile/CreatePhotoURL";

const db = getFirestore(app);
const tempUser = localStorage.getItem("userUID");
const tempEmail = localStorage.getItem("userEmail");
const tempUserEmail = "";
const tempUserName = "";

function reloadPage() {
  window.location.reload();
}
function AllGroups() {
  const [getSelect, setGetSelect] = useState(false);
  const [messages, setMessages] = useState(
    "Select a group to edit and then press Save after editing, or enter details for a new group and press Create. Note that to add users to a new group you must first create the group and after that you can add users."
  );
  const [selectUsers, setSelectUsers] = useState("none");
  const [selectProjects, setSelectProjects] = useState("none");

  //Buttons
  const [saveButtonDisabled, setSaveButtonDisabled] = useState(true);
  const [createButtonDisabled, setCreateButtonDisabled] = useState(false);
  const [deleteButtonDisabled, setDeleteButtonDisabled] = useState(true);
  const [subgroupsButtonDisabled, setSubgroupsButtonDisabled] = useState(true);
  const [projectsButtonDisabled, setProjectsButtonDisabled] = useState(true);

  const [addToGroupUsersButtonDisabled, setAddToGroupUsersButtonDisabled] =
    useState(true);
  const [
    removeFromGroupUsersButtonDisabled,
    setRemoveFromGroupUsersButtonDisabled,
  ] = useState(true);

  const [userAbout, setUserAbout] = useState("");
  const [userFirstName, setUserFirstName] = useState("");
  const [userLastName, setUserLastName] = useState("");
  const [userPhotoName, setUserPhotoName] = useState("");
  const [userProfileName, setUserProfileName] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [userProfileLink1, setUserProfileLink1] = useState("");
  const [userProfileLink2, setUserProfileLink2] = useState("");
  const [userProfileLink3, setUserProfileLink3] = useState("");
  const [userProfileLink4, setUserProfileLink4] = useState("");

  //Groups
  const [groupProfiles, setGroupProfiles] = useState<NewGroupProfileType[]>([]);
  const [tempGroup, setTempGroup] = useState<NewGroupProfileType[]>([]);
  const [groupAffiliationInput, setGroupAffiliationInput] = useState("");
  const [groupTitleInput, setGroupTitleInput] = useState("");
  const [groupAdministratorInput, setGroupAdministratorInput] = useState("");
  const [groupDescriptionInput, setGroupDescriptionInput] = useState("");
  const [groupDetailedDescriptionInput, setGroupDetailedDescriptionInput] =
    useState("");

  const [lastLength, setLastLength] = useState(0);

  const [groupUserName, setGroupUserName] = useState([]);
  const [groupUserEmail, setGroupUserEmail] = useState([]);
  const [groupUserNameAndEmail, setGroupUserNameAndEmail] = useState([]);

  const [groupRefArray, setGroupRefArray] = useState([]);

  //let groupRefArray: string[] = [];
  let groupTitles: string[] = [];
  let groupAdministrator: string[] = [];
  let groupDescriptions: string[] = [];
  let groupDetailedDescriptions: string[] = [];
  let groupAffiliation: string[] = [];

  //The index into group listbox starts with 1 because of "Group Selection" text as
  //item 0
  const [groupTitlesIndex, setGroupTitlesIndex] = useState([0]);
  //let groupTitlesIndex = 1;

  //Users
  const [userProfiles, setUserProfiles] = useState<NewUserProfileType[]>([]);
  const [allUsersField, setAllUsersField] = useState<UserField[]>([]);
  const [groupAllUsersField, setgroupAllUsersField] = useState<UserField[]>([]);

  let userRefArray: string[] = [];

  const [allUsersFieldIndex, setAllUsersFieldIndex] = useState(1);
  const [allGroupUsersFieldIndex, setAllGroupUsersFieldIndex] = useState(1);
  //let allUsersFieldIndex = 1;
  //let allGroupUsersFieldIndex = 1;

  let docUserRefArray: string[] = [];
  const [userNames, setUserNames] = useState([""]);
  const [userEmails, setUserEmails] = useState([""]);
  const [userNamesAndEmails, setUserNamesAndEmails] = useState([""]);
  let tempUserProfile: NewUserProfileType;
  let tempProfile: NewUserProfileType;

  var bodyStyles = document.body.style;

  let photoRef = "";

  const GroupUsersSelected = async (e: ChangeEvent<HTMLSelectElement>) => {
    console.log("in group user selected...");

    if (e.currentTarget.selectedIndex == 0) {
      return;
    }

    //allGroupUsersFieldIndex = e.currentTarget.selectedIndex;
    setAllGroupUsersFieldIndex(e.currentTarget.selectedIndex - 1);

    //Now retrieve the user profile and display it...
    console.log(" all groupusers selected index is ", allGroupUsersFieldIndex);
    console.log(
      " all groupusers selected index really is ",
      e.currentTarget.selectedIndex
    );
    //Using the index retrieve the userEmail
    const tempGroupUserEmail =
      groupUserEmail[e.currentTarget.selectedIndex - 1];
    console.log("all group users are ", groupUserEmail);
    console.log("retrieved user email is ", tempGroupUserEmail);
    //Now query userProfiles to retrieve the entire profile and set the display fields

    const q0 = query(
      collection(db, "userProfiles"),
      where("userEmail", "==", tempGroupUserEmail)
    );
    const querySnapshot = await getDocs(q0);
    let k = 0;
    querySnapshot.forEach((doc) => {
      // doc.data() is never undefined for query doc snapshots
      console.log(doc.id, " => ", doc.data());
      console.log("doc data = ", doc.data());
      if (
        doc.data().userFirstName === "" ||
        doc.data().userFirstName == undefined
      ) {
        setUserFirstName(" ");
      } else {
        setUserFirstName(doc.data().userFirstName);
      }
      if (
        doc.data().userLastName === "" ||
        doc.data().userLastName == undefined
      ) {
        setUserLastName(" ");
      } else {
        setUserLastName(doc.data().userLastName);
      }
      if (
        doc.data().userProfileName === "" ||
        doc.data().userProfileName == undefined
      ) {
        setUserProfileName(" ");
      } else {
        setUserProfileName(doc.data().userProfileName);
      }
      if (doc.data().userEmail === "" || doc.data().userEmail == undefined) {
        setUserEmail(" ");
      } else {
        setUserEmail(doc.data().userEmail);
      }
      console.log("doc.data().userAbout", doc.data().userAbout);
      if (doc.data().userAbout === "" || doc.data().userAbout == undefined) {
        setUserAbout(" ");
        console.log("user about set from undefined or empty");
      } else {
        setUserAbout(doc.data().userAbout);
        console.log("user about set from value");
      }
      if (
        doc.data().userProfileLink1 === "" ||
        doc.data().userProfileLink1 == undefined
      ) {
        setUserProfileLink1(" ");
      } else {
        setUserProfileLink1(doc.data().userProfileLink1);
      }
      if (
        doc.data().userProfileLink2 === "" ||
        doc.data().userProfileLink2 == undefined
      ) {
        setUserProfileLink2(" ");
      } else {
        setUserProfileLink2(doc.data().userProfileLink2);
      }
      console.log("doc.data().userProfileLink3", doc.data().userProfileLink3);
      if (
        doc.data().userProfileLink3 === "" ||
        doc.data().userProfileLink3 == undefined
      ) {
        setUserProfileLink3(" ");
      } else {
        setUserProfileLink3(doc.data().userProfileLink3);
      }
      console.log("doc.data().userProfileLink4", doc.data().userProfileLink4);
      if (
        doc.data().userProfileLink4 === "" ||
        doc.data().userProfileLink4 == undefined
      ) {
        setUserProfileLink4(" ");
      } else {
        setUserProfileLink4(doc.data().userProfileLink4);
      }
      setUserPhotoName(CreatePhotoURL(doc.data().userPhotoName));

      console.log("photo name = ", CreatePhotoURL(doc.data().userPhotoName));
      //tempProfile[k].push(doc.data());
      k++;
    });

    //console.log("tempProfile = ", tempProfile);
    //Now set the display fields according to the profile
    //setUserFirstName(tempProfile[0].userFirstName);
    //setUserLastName(tempProfile[0].userLastName);
    //setUserProfileName(tempProfile[0].userProfileName);
  };

  const GroupSelected = (e: React.ChangeEvent<HTMLSelectElement>) => {
    //When a group is selected we must:
    //1. Retrieve the group's details and fill in the page
    //2. Retrieve the userGroup entries and fill them in and note that we need to pop
    //all the existing entries first, i.e. for length >= 1

    //4. Set the get select to true
    //5. Set the new groupSelectedIndex (groupTitlesIndex[0])

    //Problem...we just changed groupTitlesIndex[0] to be useState however there is a
    //delay when we set it so what follows, which depends on immediacy, is all wrong.

    const tempIndex = e.currentTarget.selectedIndex;
    if (tempIndex == 0) {
      window.location.reload();
      return;
    }

    console.log("GroupSelected entered");
    setGetSelect(true);
    //setGroupTitlesIndex(e.currentTarget.selectedIndex);
    console.log("tempIndex -1 = ", tempIndex - 1);

    setSubgroupsButtonDisabled(false);
    setProjectsButtonDisabled(false);
    //lastLength is the length of the last groupUser entries
    console.log("lastLength = ", lastLength);
    //groupTitleInput.current = "x";
    setGroupTitleInput(groupTitles[tempIndex - 1]);
    setGroupAdministratorInput(groupAdministrator[tempIndex - 1]);
    setGroupAffiliationInput(groupAffiliation[tempIndex - 1]);
    setGroupDescriptionInput(groupDescriptions[tempIndex - 1]);
    setGroupDetailedDescriptionInput(groupDetailedDescriptions[tempIndex - 1]);
    localStorage.setItem("currentGroup", groupTitles[tempIndex - 1]);
    //If this is true then lastLength ought to be reset to the new length
    for (
      let i = 0;
      i < lastLength - groupProfiles[tempIndex - 1].groupUsers.length;
      i++
    ) {
      groupUserName.pop();
      groupUserEmail.pop();
      groupUserNameAndEmail.pop();
    }

    console.log("last length was = ", lastLength);
    console.log(
      "reset lastLength to ",
      groupProfiles[tempIndex - 1].groupUsers.length
    );
    setLastLength(groupProfiles[tempIndex - 1].groupUsers.length);
    for (let i = 0; i < groupProfiles[tempIndex - 1].groupUsers.length; i++) {
      var myObject = groupProfiles[tempIndex - 1].groupUsers[i];
      const resEmail: string = myObject["userEmail"];

      groupUserEmail[i] = resEmail;
      const resName: string = myObject["userName"];
      groupUserName[i] = resName;
      console.log("i = ", i);
      console.log(
        "groupUsers obj = ",
        groupProfiles[tempIndex - 1].groupUsers[i]
      );

      console.log("email = ", groupUserEmail[i]);
      console.log("name = ", groupUserName[i]);
      groupUserNameAndEmail[i] =
        groupUserName[i] + "\xa0\xa0\xa0\xa0\xa0\xa0" + groupUserEmail[i];
      console.log("nameandemail = ", groupUserNameAndEmail[i]);
    }
    console.log(
      " group users length = ",
      groupProfiles[tempIndex - 1].groupUsers.length
    );
    console.log(
      "new lastLength should be = ",
      groupProfiles[tempIndex - 1].groupUsers.length
    );
    console.log("new lastLength actual is = ", lastLength);
  };

  //const q0 = query(
  //  collection(db, "userProfiles"),
  //  where("userUID", "==", tempUser),
  //);
  //useEffect(
  //  () =>
  //    onSnapshot(q0, (snapshot) => {
  //      setUserProfiles(
  //        snapshot.docs.map((doc) => {
  //          return {
  //            id: doc.id,
  //            ...doc.data(),
  //          };
  //        })
  //      );
  //    }),
  //  []
  //);

  console.log("user email is = ", tempEmail);

  //Setup the all" users list with profile name and email listed together in a listbox
  //const q1 = query(
  //  collection(db, "userProfiles"),
  //  where("userProfileName", "!=", ""),
  //  orderBy("userProfileName")
  // );
  //useEffect(
  //  () =>
  //    onSnapshot(q1, (snapshot) => {
  //      //userProfiles will consist of both profile name and email which will be
  //      //put together using the UserField Interface. There will be 2 uses of the
  //      //interface: one for all users and one for just the group's users
  //      setUserProfiles(
  //        snapshot.docs.map((doc) => {
  //          console.log(" adminInfo 3 user id = ", doc.id);
  //          console.log(" adminInfo 33 user data = ", doc.data());

  //          if (doc.id) {
  //            //userNames.push(thisUserName);
  //            //setUserProfiles(user);
  //            docUserRefArray.push(doc.id);
  //            //setUserProfiles(doc.data());

  //           //console.log("userNames array = ", userNames);
  //            //console.log("docUseRefArray = ", docUserRefArray);
  //          }
  //          return {
  //            //let user[doc.id] = doc.data();
  //            id: doc.id,
  //            ...doc.data(),
  //          };
  //          //return {};
  //        })
  //      );
  //    }),
  //[]
  //);

  //console.log("after setUserProfiles userprofiles = ", userProfiles);
  //if (userProfiles) {
  //console.log(" adminInfo 4 userProfiles = ", userProfiles);
  //  tempUserProfile = userProfiles;
  //  //console.log("tempUserProfile = ", tempUserProfile);
  //  let tempUserName = tempUserProfile.userProfileName;
  //console.log(" tempUserName = ", tempUserName);

  //  let tempUserEmail = tempUserProfile.userEmail;

  //  for (let i = 0; i < userProfiles.length; i++) {
  //    userNames[i] = userProfiles[i].userProfileName;
  //    userEmails[i] = userProfiles[i].userEmail;
  //    userNamesAndEmails[i] =
  //      userNames[i] + "\xa0\xa0\xa0\xa0\xa0\xa0" + userEmails[i];
  //  }
  //console.log("user names array = ", userNames);
  //console.log("user emails array = ", userEmails);
  //console.log("user names and emails array = ", userNamesAndEmails);
  //}
  const q2 = query(
    collection(db, "Groups"),
    where("title", "!=", ""),

    orderBy("title")
  );
  useEffect(
    () =>
      onSnapshot(q2, (snapshot) => {
        setGroupProfiles(
          snapshot.docs.map((doc) => {
            let i = 0;
            console.log(" adminSelect 1 doc id = ", doc.id);
            console.log(" adminSelect 2 projectProfiles = ", groupProfiles);

            if (doc.id) {
              console.log(
                " AdminSelect got a doc id from onSnapshot for groups "
              );

              console.log("doc.id = ", doc.id);
              console.log("groupRefArray.length = ", groupRefArray.length);
              console.log(
                " before check and groupTitlesIndex[0] = ",
                groupTitlesIndex[0]
              );
              let found = false;
              for (let i = 0; i < groupRefArray.length; i++) {
                if (groupRefArray[i] === doc.id) {
                  found = true;
                  break;
                }
              }
              if (found === false) {
                //console.log(
                //  " found is false and before pop groupTitlesIndex[0] = ",
                //  groupTitlesIndex[0]
                //);
                groupRefArray.push(doc.id);
                let temp = groupTitlesIndex.pop();
                temp++;
                groupTitlesIndex.push(temp);
                console.log("temp = ", temp);
              } else {
                console.log(" else and groupRefArray = ", groupRefArray);
                console.log(
                  " else and groupTitlesIndex[0] = ",
                  groupTitlesIndex[0]
                );
              }
              console.log("groupTitlesIndex[0] = ", groupTitlesIndex[0]);
              console.log(" groupRefArray  ", groupRefArray);
              console.log(" doc data () ", doc.data());
              console.log("doc.data().title = ", doc.data().title);
            }
            return {
              id: doc.id,
              ...doc.data(),
            };
            //i++;
            //return {};
          })
        );
      }),
    []
  );
  //Now that we are changing this logic to include all groups for which this user belongs
  //we have to use who this user is and make the additions to the groupTitles listbox
  //more intelligent:
  //     where("administratorUID", "==", tempUser) or
  //     we need to extract the users from groupUsers (if defined)
  //     and see if tempUser belongs and note that we can't use tempUser
  //     rather we need to use the tempUser's email that was stored at login
  //     in local storage
  let k = 0;
  for (let i = 0; i < groupProfiles.length; i++) {
    //Is the user a group administrator?
    if (groupProfiles[i].administratorUID === tempUser) {
      //Yes, so push the entire group profile onto the tempGroup array
      //tempGroup.push(groupProfiles[i]);
      console.log(
        "groupUsers length for i = ",
        i,
        "is = ",
        groupProfiles.length
      );
      console.log("groupProfiles[i] = ", groupProfiles[i]);
      tempGroup[k] = groupProfiles[i];
      k++;
    } else {
      //Is there a defined groupUsers entry in this group?
      console.log(
        "groupUsers length for i = ",
        i,
        "is = ",
        groupProfiles.length
      );
      console.log("groupProfiles[i] = ", groupProfiles[i]);
      if (groupProfiles[i].groupUsers !== undefined) {
        //Yes, so check to see if the user is listed as one of the groupUsers
        for (let j = 0; j < groupProfiles[i].groupUsers.length; j++) {
          //Get the groupUser's email
          let myObject = groupProfiles[i].groupUsers[j];
          const resEmail: string = myObject["userEmail"];
          console.log("resEmail = ", resEmail);
          //Does the groupuser's email match this user's email?
          if (resEmail === tempEmail) {
            //Yes, so push the entire group profile onto the tempGroup array
            tempGroup[k] = groupProfiles[i];
            //setTempGroup[k] = groupProfiles[i];
            k++;
            break;
          }
        }
      }
    }
  }

  //This logic is filling in the groupTitles array, which is the input to
  //the group selection listbox. At this juncture we should already have
  //prequalified the candidate entries, which is to say that we need a further
  //array, post group query, that produces the needed and qualified array and
  //then that is the array we should use here instead of the entire groupProfiles.

  //First, make sure that tempGroup is defined
  console.log("tempGroup = ", tempGroup);
  if (tempGroup !== undefined) {
    for (let i = 0; i < tempGroup.length; i++) {
      console.log("i = ", i);
      groupTitles[i] = groupProfiles[i].title;
      groupAdministrator[i] = groupProfiles[i].administratorName;
      console.log("group titles[i] = ", groupTitles[i]);
      groupDescriptions[i] = groupProfiles[i].description;
      console.log("groupDescriptions[i] = ", groupDescriptions[i]);
      groupDetailedDescriptions[i] = groupProfiles[i].detailedDescription;
      console.log(
        "groupDetailedDescriptions[i] = ",
        groupDetailedDescriptions[i]
      );
      groupAffiliation[i] = groupProfiles[i].groupAffiliation;
      console.log("groupAffiliation[i] ", groupAffiliation[i]);
      //console.log(" 1 group array ids [1] = ", groupRefArray[1]);
      //console.log("group profiles length = ", groupProfiles.length);
      //console.log("groupUser [i] email = ", groupProfiles[i].groupUsers[0]);
      groupProfiles[i].groupUsers.forEach((item) =>
        console.log("item in groupUsers =", item)
      );
    }
  }

  return (
    <div>
      <>
        <div>
          <div className={styles.wrapper}>
            <div className={styles.top}>
              <label
                style={{
                  marginLeft: 0,
                  fontWeight: 550,
                  fontSize: 25,
                  marginTop: 0,
                }}
              >
                All Groups
              </label>
            </div>
            <br />
            <div>
              <div>
                <label
                  className={styles.forh3}
                  style={{ marginLeft: 50, fontWeight: 550, fontSize: 20 }}
                >
                  Group List
                </label>
                <select
                  name="Group List"
                  id="group-select"
                  onChange={GroupSelected}
                  style={{ marginLeft: 51 }}
                >
                  <option value="">-- Group Selection --</option>
                  {groupTitles.map((groupTitles, key) => (
                    <option key={key} value={groupTitles}>
                      {groupTitles}
                    </option>
                  ))}
                </select>
                <a href="WelcomePage">
                  <button
                    id="closeButtonID"
                    className={styles.buttonClass}
                    style={{ marginLeft: 400, marginTop: -48 }}
                  >
                    Close
                  </button>
                </a>
              </div>
            </div>

            <div className={styles.aimLabel}>
              <label style={{ marginLeft: 30, marginTop: 5 }}>
                Affiliation
              </label>
              <textarea
                id="input_Title"
                className={styles.messageText}
                rows={3}
                cols={80}
                readOnly
                style={{
                  paddingLeft: 3,
                  marginLeft: 85,
                  width: 460,
                  height: 17,
                  marginTop: 3,
                }}
                defaultValue={groupAffiliationInput}
              />
              <br />
            </div>

            <div className={styles.aimLabel}>
              <label style={{ marginLeft: 30, marginTop: 5 }}>Title</label>
              <textarea
                id="input_Title"
                className={styles.messageTextTitle}
                rows={3}
                cols={80}
                readOnly
                style={{
                  paddingLeft: 3,
                  marginLeft: 119,
                  width: 460,
                  height: 17,
                  marginTop: 3,
                }}
                defaultValue={groupTitleInput}
              />
              <br />
            </div>

            <div className={styles.aimLabel}>
              <label style={{ marginLeft: 30, marginTop: 5 }}>
                Administrator
              </label>
              <textarea
                id="input_Title"
                className={styles.messageTextTitle}
                rows={3}
                cols={80}
                readOnly
                style={{
                  paddingLeft: 3,
                  marginLeft: 55,
                  width: 460,
                  height: 17,
                  marginTop: 3,
                }}
                defaultValue={groupAdministratorInput}
              />
              <br />
            </div>

            <div className={styles.aimLabel}>
              <label style={{ marginLeft: 30 }}>Description</label>
              <textarea
                className={styles.messageText}
                rows={3}
                cols={80}
                readOnly
                style={{
                  paddingLeft: 3,
                  marginLeft: 67,
                  width: 460,
                  height: 50,
                }}
                defaultValue={groupDescriptionInput}
              />
            </div>
            <div className={styles.aimLabel}>
              <label style={{ marginLeft: 30 }}>Details</label>
              <textarea
                className={styles.messageText}
                rows={3}
                cols={80}
                readOnly
                style={{
                  paddingLeft: 3,
                  marginLeft: 97,
                  width: 460,
                  height: 75,
                }}
                defaultValue={groupDetailedDescriptionInput}
              />
            </div>
            <br />

            <div>
              <div>
                <label
                  className={styles.forh3}
                  style={{
                    marginLeft: 50,
                    fontWeight: 500,
                    fontSize: 18,
                    marginRight: 10,
                    marginTop: 5,
                  }}
                >
                  Group Users
                </label>
                <select
                  name="Lab Group List"
                  id="labgroup-select"
                  size={groupUserNameAndEmail.length + 1}
                  style={{ marginLeft: 32, padding: 3 }}
                  onChange={GroupUsersSelected}
                >
                  <option value="">-- Lab Group Selection --</option>
                  {groupUserNameAndEmail.map((groupUserNameAndEmail, key) => (
                    <option key={key} value={groupUserNameAndEmail}>
                      {groupUserNameAndEmail}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className={styles.aimLabel}>
              <label style={{ marginLeft: 60, marginTop: 5 }}>First Name</label>
              <textarea
                id="input_Title"
                className={styles.messageText}
                rows={3}
                cols={80}
                readOnly
                style={{
                  paddingLeft: 3,
                  marginLeft: 35,
                  width: 130,
                  height: 17,
                  marginTop: 3,
                }}
                value={userFirstName}
              />
              <label style={{ marginLeft: 35, marginTop: 5 }}>Last Name</label>
              <textarea
                id="input_Title"
                className={styles.messageText}
                rows={3}
                cols={80}
                readOnly
                style={{
                  paddingLeft: 3,
                  marginLeft: 27,
                  width: 190,
                  height: 17,
                  marginTop: 3,
                }}
                value={userLastName}
              />
            </div>
            <div className={styles.aimLabel}>
              <label style={{ marginLeft: 60, marginTop: 5 }}>
                Profile Name
              </label>
              <textarea
                id="input_Title"
                className={styles.messageText}
                rows={3}
                cols={80}
                readOnly
                style={{
                  paddingLeft: 3,
                  marginLeft: 20,
                  width: 130,
                  height: 17,
                  marginTop: 3,
                }}
                value={userProfileName}
              />
              <label style={{ marginLeft: 35, marginTop: 5 }}>Email</label>
              <textarea
                id="input_Title"
                className={styles.messageText}
                rows={3}
                cols={80}
                readOnly
                style={{
                  paddingLeft: 3,
                  marginLeft: 63,
                  width: 191,
                  height: 17,
                  marginTop: 3,
                }}
                value={userEmail}
              />
            </div>
            <div className={styles.aimLabel}>
              <label style={{ marginLeft: 60, marginTop: 5 }}>About</label>
              <textarea
                id="input_Title"
                className={styles.messageText}
                rows={3}
                cols={80}
                readOnly
                style={{
                  paddingLeft: 3,
                  marginLeft: 70,
                  width: 459,
                  height: 155,
                  marginBottom: -30,
                }}
                value={userAbout}
              />
            </div>
            <br></br>
            <br></br>
            <br></br>
            <div className={styles.row}>
              <div className={styles.column}>
                <img
                  src={userPhotoName}
                  alt=""
                  style={{
                    paddingTop: 0,
                    paddingLeft: 20,
                    paddingRight: 20,
                    height: 200,
                    objectFit: "scale-down",
                    marginLeft: 28,
                  }}
                />
              </div>
              <div className={styles.column}>
                <input
                  style={{
                    paddingLeft: 3,
                    width: 320,
                    height: 17,
                    marginLeft: 0,
                  }}
                  type="text"
                  readOnly
                  defaultValue={userProfileLink1}
                />
                <a href={userProfileLink1} target="_blank">
                  <button
                    style={{
                      width: 50,
                      backgroundColor: "Gainsboro",
                      borderRadius: 10,
                      marginLeft: 100,
                    }}
                  >
                    Open
                  </button>
                </a>
                <div>
                  <input
                    style={{
                      paddingLeft: 3,
                      width: 320,
                      height: 17,
                      marginLeft: 0,
                    }}
                    type="text"
                    readOnly
                    defaultValue={userProfileLink2}
                  />
                  <a href={userProfileLink2} target="_blank">
                    <button
                      style={{
                        width: 50,
                        marginLeft: 100,
                        backgroundColor: "Gainsboro",
                        borderRadius: 10,
                      }}
                    >
                      Open
                    </button>
                  </a>
                </div>
                <div>
                  <input
                    style={{
                      paddingLeft: 3,
                      width: 320,
                      height: 17,
                      marginLeft: 0,
                    }}
                    type="text"
                    readOnly
                    defaultValue={userProfileLink3}
                  />
                  <a href={userProfileLink3} target="_blank">
                    <button
                      style={{
                        width: 50,
                        marginLeft: 100,
                        backgroundColor: "Gainsboro",
                        borderRadius: 10,
                      }}
                    >
                      Open
                    </button>
                  </a>
                </div>

                <div>
                  <input
                    style={{
                      paddingLeft: 3,
                      width: 320,
                      height: 17,
                      marginLeft: 0,
                    }}
                    type="text"
                    readOnly
                    defaultValue={userProfileLink4}
                  />
                  <a href={userProfileLink4} target="_blank">
                    <button
                      style={{
                        width: 50,
                        marginLeft: 100,
                        backgroundColor: "Gainsboro",
                        borderRadius: 10,
                      }}
                    >
                      Open
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </div>
  );
}

export default AllGroups;
